import React, { createContext, useContext, useEffect, useState } from 'react';
import { subscribeRecipes, subscribePantry, savePantry } from '../utils/firebase';
import { useAuth } from './AuthContext';

const RecipeContext = createContext(null);

export function RecipeProvider({ children }) {
  const { user } = useAuth();
  const [recipes, setRecipes] = useState([]);
  const [recipesLoading, setRecipesLoading] = useState(true);
  const [pantry, setPantry] = useState({ items: [] });
  const [pantryLoading, setPantryLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRecipes([]);
      setPantry({ items: [] });
      setRecipesLoading(false);
      setPantryLoading(false);
      return;
    }

    setRecipesLoading(true);
    const unsubRecipes = subscribeRecipes(user.uid, (data) => {
      setRecipes(data);
      setRecipesLoading(false);
    }, () => setRecipesLoading(false));

    setPantryLoading(true);
    const unsubPantry = subscribePantry(user.uid, (data) => {
      setPantry(data);
      setPantryLoading(false);
    }, () => setPantryLoading(false));

    return () => {
      unsubRecipes();
      unsubPantry();
    };
  }, [user]);

  const updatePantry = async (items) => {
    if (!user) return;
    await savePantry(user.uid, items);
  };

  return (
    <RecipeContext.Provider value={{ recipes, recipesLoading, pantry, pantryLoading, updatePantry }}>
      {children}
    </RecipeContext.Provider>
  );
}

export function useRecipes() {
  return useContext(RecipeContext);
}
